import React from 'react';
import LearningLayout from '../Components/LearningPlatform/LearningLayout';
import ProgressSection from '../Components/LearningPlatform/ProgressSection';

function ProgressPage() {
    return (
        <LearningLayout>
            <div className='flex-1 overflow-auto flex flex-col'>
                {/* Content */}
                <div className='container mx-auto px-4 sm:px-6 lg:px-8 py-8'>
                    <div className='max-w-6xl mx-auto'>
                        <ProgressSection />
                    </div>
                </div>
            </div>
        </LearningLayout>
    );
}

export default ProgressPage;
